// @flow

import { beginRequest, completeRequest } from "@store/utils";
import type { AbsenceReviewState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetLastAbsenceReviewTask = (state: AbsenceReviewState) => () => startRequest(state);

export const onGetLastAbsenceReviewTaskSuccess = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  lastReviewTask: payload,
});

export const onGetLastAbsenceReviewTaskError = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetAbsenceReviewTask = (state: AbsenceReviewState) => () => startRequest(state);

export const onGetAbsenceReviewTaskSuccess = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  selectedReviewTask: payload,
});

export const onGetAbsenceReviewTaskError = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetReferralDecisionTaskData = (state: AbsenceReviewState) => () => ({
  ...state,
  referralDecisionTask: null,
});

export const onGetReferralDecisionTaskDataSuccess = (state: AbsenceReviewState) => ({
  payload,
}: Object) => {
  return { ...state, referralDecisionTask: payload };
};

export const onCreateAbsenceReviewTask = (state: AbsenceReviewState) => () => startRequest(state);

export const onCreateAbsenceReviewTaskSuccess = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  task: payload,
});

export const onCreateAbsenceReviewTaskError = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onCancelAbsenceReviewTask = (state: AbsenceReviewState) => () => startRequest(state);

export const onCancelAbsenceReviewTaskSuccess = (state: AbsenceReviewState) => () => ({
  ...state,
  ...finishRequest(state),
  error: null,
  task: null,
  lastReviewTask: null,
});

export const onCancelAbsenceReviewTaskError = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onSubmitAbsenceReviewTask = (state: AbsenceReviewState) => () => startRequest(state);

export const onSubmitAbsenceReviewTaskSuccess = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  task: null,
  lastReviewTask: null,
});

export const onSubmitAbsenceReviewTaskError = (state: AbsenceReviewState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});
